<template>
  <div class="login">
    <div class="title">请选择您要登录的商户</div>
    <div class="list">
      <van-radio-group v-model="radio">
        <div class="list-item" v-for="(item, index) in choiceList" :key="index">
          <van-radio :name="item.traderId">
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? checkedIcon : checkedNoIcon"
              />
              <div class="business-name">{{ item.traderName }}</div>
            </template>
          </van-radio>

          <span class="business-type" v-if="item.type == 'person'">个人</span>
          <span class="user-type" v-else>企业</span>
        </div>
      </van-radio-group>
    </div>

    <div class="submit-btn" @click="handleSubmit">确认</div>
  </div>
</template>

<script>
import checkedIcon from './img/checked.png';
import checkedNoIcon from './img/checked_no.png';
import { apiGetAppUserInfo, apiGetInfo_userId } from '@/api/dq.js'
import {authLogin} from '@/views/dq/hooks.js'
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};

export default {
  data() {
    return {
      radio: '',
      checkedIcon,
      checkedNoIcon,
      choiceList: [],
    };
  },
  computed:{
    mobile(){
      return this.$store.state.account.mobile
    },
    userId(){
      return this.$store.state.account.userId
    }
  },
  methods: {
    async getChoiceList() {

      if(!isWechat()){
        let res = await apiGetInfo_userId(this.userId)
        // authLogin(res)
        // return

        // if(!(res.companyTraders || res.individualId)){
        //   this.$toast('您不是个体商户或企业商户,请注册后登录');
        //   this.$router.push({
        //     path:`/dq/agreement?mobile=${this.mobile}`
        //   })
        //   return
        // }
        let userInfo = this.$store.state.base.userInfo
        this.$store.commit('base/setUserInfo', {
          ...userInfo,
          companyTraders:res.data.companyTraders,
          individualName:res.data.individualName
        });
      }

      let userInfo = JSON.parse(
        JSON.stringify(this.$store.state.base.userInfo)
      );

      let companyTraders = userInfo.companyTraders || [];
      // if (!isWechat()) {

      //   companyTraders = JSON.parse(userInfo.companyTraders) || [];
      // } else {
      //   companyTraders = userInfo.companyTraders || [];
      // }
      if (userInfo.individualName) {
        companyTraders.push({
          id: userInfo.id || userInfo.userId,
          traderId: userInfo.id || userInfo.userId,
          traderName: userInfo.individualName,
          type: 'person',
        });
      }

      this.choiceList = companyTraders;
    },
    handleSubmit() {
      if (!this.radio) return this.$toast('请选择您要登录的商户');
      let item = this.choiceList.find((v) => v.traderId == this.radio);
      if (item.type == 'person') {
        // 个人
        let base = {
          userId: item.id,
          traderName: item.traderName,
        };
        this.$router.push({
          path: '/dq/agreementList',
          query: base,
        });
      } else {
        // 企业 /dq/agreementList || /dq/business_sign

        let base = {
          traderId: item.traderId,
          traderName: item.traderName,
        };

        let manager = item.merchantInfos.find((el) => el.type == 1);

        if (manager) {
          // 管理员

          this.$router.push({
            path: '/dq/business_sign',
            query: {
              ...base,
              type: item.merchantInfos.find((el) => el.type == 2) ? '1,2' : '1'
            },
          });
        } else {
          // 保管员

          this.$router.push({
            path: '/dq/agreementList',
            query: {
              ...base,
              type: '2',
            },
          });
        }
      }
    },
  },
  mounted() {
    this.getChoiceList();
  },
};
</script>

<style lang="less" scoped>
.login {
  line-height: 1;
  font-size: 16px;
  background: #f3f5f6;
  padding: 20px 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  text-align: left;
  overflow: auto;

  .title {
  }

  .list {
    .list-item {
      padding: 16px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      margin-top: 10px;
      border-radius: 8px;
      .van-radio {
        flex: 1;
      }
      /deep/.van-radio__icon {
        display: flex;
        align-items: center;
      }
      .img-icon {
        height: 16px;
        width: 16px;
      }
      .business-name {
        font-size: 14px;
        margin-left: 5px;
      }
      .business-type {
        font-size: 13px;
        background: #e9f8fd;
        border-radius: 2px;
        padding: 4px 8px;
        color: #65b2f6;
      }
      .user-type {
        font-size: 13px;
        background: #fdf6e9;
        border-radius: 2px;
        padding: 4px 8px;
        color: #fc9127;
      }
    }
  }
}
.submit-btn {
  width: 232px;
  text-align: center;
  height: 44px;
  line-height: 44px;
  background: #FF6F00;
  border-radius: 22px;
  color: #fff;
  margin: 40px auto;
}
</style>